import { LOCAL_STORAGE } from '~/plugins/constants/localStorage';
import { ROUTE } from '~/plugins/constants/route';
import { getLocalStorage } from '~/plugins/functions/localStorage';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const accessToken = getLocalStorage(
    LOCAL_STORAGE.OAUTH_BACK_OFFICE_ACCESS_TOKEN
  );
  const router = useRouter();
  // if (!router.resolve(to.path).matched.length) {
  //   console.log('condition 3');
  //   return navigateTo(ROUTE.HOME.LINK, { replace: true });
  // } else
  if (accessToken && to.path === ROUTE.LOGIN.LINK) {
    return navigateTo(ROUTE.HOME.LINK);
  } else if (
    !accessToken &&
    to.path !== ROUTE.LOGIN.LINK
    // &&
    // to.path !== ROUTE.REGISTER.LINK
  ) {
    console.log('condition 2');
    return navigateTo(ROUTE.LOGIN.LINK);
  }
});
